module.exports = __webpack_public_path__ + "06_long_brown.55910669.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_long_brown.png
// module id = qg86
// module chunks = 0